import asanaOAuthService from '../../../services/asanaOAuthService'
import atlassianOAuthService from '../../../services/atlassianOAuthService'
import githubOAuthService from '../../../services/githubOAuthService'

const PROVIDER_LABELS = {
  github: 'GitHub',
  jira: 'Jira',
  asana: 'Asana',
}

export function oauthProviderLabel(provider) {
  return PROVIDER_LABELS[provider] || provider
}

export function stripUrls(text) {
  if (!text) return ''
  return text.replace(/https?:\/\/\S+/g, '').replace(/\s{2,}/g, ' ').trim()
}

export async function launchOAuthConnect(provider) {
  switch (provider) {
    case 'github':
      return githubOAuthService.initiateOAuthFlow()
    case 'jira':
      return atlassianOAuthService.initiateOAuthFlow()
    case 'asana':
      return asanaOAuthService.initiateOAuthFlow()
    default:
      throw new Error(`Unknown OAuth provider: ${provider}`)
  }
}
